<template>
  <div>
    <Echart id="centreLeft2Chart" ref="centreLeft2ChartRef" :options="options" height="360px" width="100%"></Echart>
  </div>
</template>

<script>
  import Echart from '@/common/echart';
  export default {
    data() {
      return {
        options: {},
      };
    },
    components: {
      Echart,
    },
    props: {
      cdata: {
        type: Array,
        default: () => [],
      },
    },
    watch: {
      cdata: {
        handler(newData) {
          this.options = {
            title: {
              // text: 'Referer of a Website',
              subtext: '职称分布',
              left: 'center'
            },
            tooltip: {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d})%",

            },
            legend: {
              orient: 'vertical',
              left: 'left',
              data:[]
            },
            
            series: [{
              name: '职称分布',
              type: 'pie',
              radius: '50%',
              data: newData,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              // itemStyle: {
              //   normal: {
              //     label: {
              //       show: true,
              //       formatter: '{b} : {c} ({d}%)'
              //     },
              //     labelLine: {
              //       show: true
              //     }
              //   }
              // }
            }]
          };
        },
        immediate: true,
        deep: true,
      },
    },
    methods: {

    },
  };
</script>